import React from 'react';
import PropTypes from 'prop-types';

const withQuoteFlatten = (Component) => (props) => {
    const { quote } = props;

    if (!quote) {
        return <Component {...props} />;
    }

    const quoteFlatten = getQuoteFlatten(quote);
    return (
        <Component
            {...props}
            {...quoteFlatten}
            quoteFlatten={quoteFlatten}
        />
    );
};

/**
 * destruct quote object to flatten
 * @param {immutable.Map} quote PropTypes.instanceOf(immutable.Map)
 * @returns {QuoteFlattenType} Flatten JSON object
 */
const getQuoteFlatten = (quote) => {
    const providerMeta = quote.get('providerMeta');
    const productMeta = quote.get('productMeta');

    const providerCode = providerMeta.get('code');
    const providerName = providerMeta.get('name');
    const providerQuoteNumber = providerMeta.get('quoteNumber');
    const providerBlurb = providerMeta.get('blurb');

    const productId = productMeta.get('id');
    const productName = productMeta.get('name');
    const productExcess = productMeta.get('excess');
    const productGlassExcess = productMeta.get('glassExcess');
    const productAdditionalExcesses = productMeta.get('additionalExcesses');
    const productAvailable = productMeta.get('available');
    const productAvailableOnline = productMeta.get('availableOnline');
    const productDisclosures = productMeta.get('productDisclosures');

    const productAnnualPremium = productMeta.getIn(['price', 'annualPremium']);
    const productMonthlyPremium = productMeta.getIn(['price', 'monthlyPremium']);
    const productMonthlyFirstMonth = productMeta.getIn(['price', 'monthlyFirstMonth']);
    const productAnnualisedMonthlyPremium = productMeta.getIn(['price', 'annualisedMonthlyPremium']);

    const productUnderwriterName = productMeta.getIn(['underwriter', 'name']);
    const productUnderwriterAcn = productMeta.getIn(['underwriter', 'acn']);
    const productUnderwriterAbn = productMeta.getIn(['underwriter', 'abn']);
    const productUnderwriterAfsl = productMeta.getIn(['underwriter', 'afsl']);

    const productDiscountOffer = productMeta.getIn(['discount', 'discountOffer']);
    const productDiscountOfferTerms = productMeta.getIn(['discount', 'discountOfferTerms']);

    const productInclusions = productMeta.get('inclusions');
    const productBenefits = productMeta.get('benefits');
    const productSpecialConditions = productMeta.get('specialConditions');
    const productOptionalExtra = productMeta.get('optionalExtras');

    const contactIsCallBackAllowed = productMeta.getIn(['contact', 'isCallBackAllowed']);
    const contactIsCallDirectAllowed = productMeta.getIn(['contact', 'isCallDirectAllowed']);
    const contactPhoneNumber = productMeta.getIn(['contact', 'phoneNumber']);
    const contactCallCentreHours = productMeta.getIn(['contact', 'callCentreHours']);

    const productSuitability = productMeta.get('productSuitability');
    const productDisclaimer = productMeta.get('disclaimer');

    const vehicleMarketValue = productMeta.getIn(['vehicleSettlement', 'marketValue']);
    const vehicleMarketValueDescription = productMeta.getIn(['vehicleSettlement', 'marketValueDescription']);
    const vehicleAgreedValue = productMeta.getIn(['vehicleSettlement', 'agreedValue']);
    const vehicleAgreedValueDescription = productMeta.getIn(['vehicleSettlement', 'agreedValueDescription']);

    return {
        providerCode,
        providerName,
        providerQuoteNumber,

        productId,
        productName,
        productExcess,
        productGlassExcess,
        productAdditionalExcesses,
        productAvailable,
        productAvailableOnline,
        productDisclosures,

        productAnnualPremium,
        productMonthlyPremium,
        productMonthlyFirstMonth,
        productAnnualisedMonthlyPremium,

        productUnderwriterName,
        productUnderwriterAcn,
        productUnderwriterAbn,
        productUnderwriterAfsl,
        providerBlurb,
        productDiscountOffer,
        productDiscountOfferTerms,

        productInclusions,
        productBenefits,
        productSpecialConditions,
        productOptionalExtra,

        contactIsCallBackAllowed,
        contactIsCallDirectAllowed,
        contactPhoneNumber,
        contactCallCentreHours,

        productSuitability,
        productDisclaimer,

        vehicleMarketValue,
        vehicleMarketValueDescription,
        vehicleAgreedValue,
        vehicleAgreedValueDescription
    };
};

const QuoteFlattenType = {
    providerCode: PropTypes.string,
    providerName: PropTypes.string,
    providerQuoteNumber: PropTypes.string,

    productId: PropTypes.string,
    productName: PropTypes.string,
    productExcess: PropTypes.string,
    productGlassExcess: PropTypes.string,
    productAdditionalExcesses: PropTypes.string,
    productAvailable: PropTypes.string,
    productAvailableOnline: PropTypes.string,
    productDisclosures: PropTypes.string,

    productAnnualPremium: PropTypes.number,
    productMonthlyPremium: PropTypes.number,
    productMonthlyFirstMonth: PropTypes.number,
    productAnnualisedMonthlyPremium: PropTypes.number,

    productUnderwriterName: PropTypes.string,
    productUnderwriterAcn: PropTypes.string,
    productUnderwriterAbn: PropTypes.string,
    productUnderwriterAfsl: PropTypes.string,
    providerBlurb: PropTypes.string,
    productDiscountOffer: PropTypes.string,
    productDiscountOfferTerms: PropTypes.string,
    productInclusions: PropTypes.string,
    productBenefits: PropTypes.string,
    productSpecialConditions: PropTypes.string,

    contactIsCallBackAllowed: PropTypes.bool,
    contactIsCallDirectAllowed: PropTypes.bool,
    contactPhoneNumber: PropTypes.string,
    contactCallCentreHours: PropTypes.string,

    productSuitability: PropTypes.string,
    productDisclaimer: PropTypes.string,

    vehicleMarketValue: PropTypes.string,
    vehicleMarketValueDescription: PropTypes.string,
    vehicleAgreedValue: PropTypes.string,
    vehicleAgreedValueDescription: PropTypes.string
};

export { withQuoteFlatten, QuoteFlattenType, getQuoteFlatten };
